import useLanguage from "../utils/useLanguage";
import DoneIcon from "../assets/done-all.svg";

export default function ConfirmationBox({ children }) {
  const { currentDirection } = useLanguage();
  return (
    <div
      className={`confirmationBox o-row `}
      style={{
        flexDirection: currentDirection === "rtl" ? "row-reverse" : "",
      }}
    >
      <p className={"confirmationBoxText"}>{children}</p>
      <img src={DoneIcon} alt="Error" />
    </div>
  );
}
